"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const classnames_1 = __importDefault(require("classnames"));
const get_1 = __importDefault(require("lodash/get"));
const prop_types_1 = __importDefault(require("prop-types"));
require("../../styles/components/animated-overflow-list-item-text.less");
const OVERFLOW_PADDING = 20;
const AnimatedOverflowListItemText = ({ className, primary, pixelsPerSecond }) => {
    const textRef = (0, react_1.useRef)(null);
    const [overflowTextStyle, setOverflowTextStyle] = (0, react_1.useState)(null);
    const [isHover, setIsHover] = (0, react_1.useState)(false);
    const onHover = (0, react_1.useCallback)(() => {
        setIsHover(true);
    }, []);
    const exitHover = (0, react_1.useCallback)(() => {
        setIsHover(false);
    }, []);
    (0, react_1.useEffect)(() => {
        const fullTextWidth = (0, get_1.default)(textRef, 'current.children[0].offsetWidth');
        const containerWidth = (0, get_1.default)(textRef, 'current.offsetWidth');
        if (fullTextWidth > containerWidth) {
            const sanitizedPixelsPerSecond = Math.max(pixelsPerSecond, 1);
            const transitionTime = (fullTextWidth - containerWidth + OVERFLOW_PADDING) / sanitizedPixelsPerSecond; // animate number (pixelsPerSecond) of pixels for second
            const overflowStyle = {
                marginLeft: -fullTextWidth - OVERFLOW_PADDING + containerWidth,
                transition: `margin ${transitionTime}s linear`,
            };
            setOverflowTextStyle({ style: overflowStyle });
        }
    }, [pixelsPerSecond]);
    return (react_1.default.createElement(ListItemText_1.default, { className: (0, classnames_1.default)('animated-overflow-list-item-text', className), primaryTypographyProps: isHover ? overflowTextStyle : null, onMouseEnter: overflowTextStyle ? onHover : null, onMouseLeave: overflowTextStyle ? exitHover : null, primary: primary, ref: textRef }));
};
AnimatedOverflowListItemText.defaultProps = {
    className: '',
    pixelsPerSecond: 90,
};
AnimatedOverflowListItemText.propTypes = {
    className: prop_types_1.default.string,
    primary: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.elementType]).isRequired,
    pixelsPerSecond: prop_types_1.default.number,
};
exports.default = AnimatedOverflowListItemText;
//# sourceMappingURL=animated-overflow-list-item-text.js.map